module.exports = __webpack_public_path__ + "img/bk_purple.acb779b0.png";